import * as React from "react";
import { DeckComponent } from "./DeckComponent";
import { ICard, ICardReference, CardSubType, IPlayerCard } from "./Card";
import { IInvestigatorInPlay } from "./Scenario";
import { IDeck, NavigateDirection } from "./Deck";
import { CardUtil } from "./CardUtil";

interface IPlayerDeckBrowserState {
    selectedIndex: number;
}

export interface IPlayerDeckBrowserProps {
    investigator: IInvestigatorInPlay;
    freePlayerCards: IPlayerCard[];
    playerCards: IPlayerCard[];
    onSellCard: (cardReference: ICardReference) => void;
}

export class PlayerDeckBrowserComponent extends React.Component<IPlayerDeckBrowserProps, IPlayerDeckBrowserState> {
    constructor(props: IPlayerDeckBrowserProps) {
        super(props);
        this.state = { selectedIndex: null };
    }
    navigate(direction: NavigateDirection): boolean {
        if (direction === NavigateDirection.Delete) {
            //cannot delete cards not existing (ie free cards)
            if (this.state.selectedIndex >= this.props.playerCards.length) {
                return true;
            }
            var pc = this.props.playerCards[this.state.selectedIndex];
            if (pc.amount == 1) {
                if (this.state.selectedIndex === 0 && this.props.playerCards.length === 1) {
                    this.setSelectedCard(null);
                } else {
                    let newPlayerCardIndex = this.state.selectedIndex;
                    if (newPlayerCardIndex >= this.props.playerCards.length) {
                        newPlayerCardIndex = this.props.playerCards.length - 2;
                    }
                    this.setSelectedCard(newPlayerCardIndex);
                }
            }
            this.props.onSellCard(pc.card);
            return true;
        }
        const cards = this.props.playerCards.map(c => c.card).concat(this.props.freePlayerCards.map((c) => c.card));

        let index = this.state.selectedIndex;
        let diff = 0;
        switch (direction) {
            case NavigateDirection.Up:
            case NavigateDirection.Left:
                diff = -1;
                break;
            case NavigateDirection.Down:
            case NavigateDirection.Right:
                diff = 1;
                break;
            default: return false;
        }
        index += diff;
        if (index < 0) {
            index = cards.length - 1;
        }
        if (index >= cards.length) {
            index = 0;
        }
        this.setSelectedCard(index);
        return true;
    }
    render() {

        const selectedDeck: IDeck = { cards: [] };
        let selectedCard: ICard = null;
        let selectedIndex = this.state.selectedIndex;
        const cards = this.props.playerCards.map(c => c.card).concat(this.props.freePlayerCards.map((c) => c.card));

        if (cards && cards.length) {
            if (!selectedIndex || selectedIndex < 0) {
                selectedIndex = 0;
            } else if (selectedIndex >= cards.length) {
                selectedIndex = cards.length - 1;
            }
            selectedCard = cards[selectedIndex]
        } else {
            selectedIndex = null;
        }



        if (selectedCard)
            selectedDeck.cards.push(selectedCard);
        const cardRows = this.props.playerCards.map((pc, i) => {
            let classNames = null;
            const c = pc.card;

            if (!selectedCard) selectedCard = c;
            if (i === this.state.selectedIndex) {
                classNames = "active";
            }
            return (<tr key={pc.key} className={classNames} onClick={() => this.setSelectedCard(i)}>
                <td><i title={CardSubType[c.subType]} className={CardUtil.getSubTypeSymbol(c.subType)}></i></td>
                <td>{c.name} {c.unique ? "*" : ""}</td>
                <td>{c.xpCost}</td>
                <td>{pc.amount}</td>
                <td><a className="sell-card" title="Sell card" onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.props.onSellCard(c);
                    return false;
                }}><i className="glyphicon glyphicon-minus"></i></a></td>
            </tr>);
        });
        const offset = this.props.playerCards.length;
        const freeCardRows = this.props.freePlayerCards.map((pc, i) => {
            let classNames = null;
            const c = pc.card;
            if (!selectedCard) selectedCard = c;
            if (offset + i === this.state.selectedIndex) {
                classNames = "active";
            }
            return (<tr key={pc.key} className={classNames} onClick={() => this.setSelectedCard(offset+i)}>
                <td><i title={CardSubType[c.subType]} className={CardUtil.getSubTypeSymbol(c.subType)}></i></td>
                <td>{c.name}</td>
                <td>{c.xpCost}</td>
                <td>{pc.amount}</td>
                <td></td>
            </tr>);
        });
        if (selectedIndex !== this.state.selectedIndex) {
            setTimeout(() => { this.setSelectedCard(selectedIndex); });
        }
        return (
            <div className="deck-browser">
                <div className="row">
                    <div className="col col-md-6">
                        <DeckComponent deck={selectedDeck} settings={{ toolbar: { flip: false, navigate: (d) => { return this.navigate(d); } } }} />
                    </div>
                    <div className="col col-md-6">
                        <table>
                            <thead>
                                <tr><th>Type</th><th>Name</th><th>Level</th><th>#</th><th></th></tr>
                            </thead>
                            <tbody>
                                {cardRows}
                                <tr><th colSpan={4}>Free Cards</th></tr>
                                {freeCardRows}
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        );
    }

    setSelectedCard(index: number) {
        this.setState({ selectedIndex: index });
    }
}
